import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "links", "dateFrom", "amountOfDays"]

  pickDate(e) {
    let dates = e.target.dataset.value
    if (!dates) return

    // Buscar los links en el modal (puede estar dentro o fuera del controlador)
    const linksContainer = document.getElementById('delivery-zone-links')
    if (!linksContainer) return

    const links = linksContainer.querySelectorAll('a')
    for (let link of links) {
      const url = new URL(link.href)
      url.searchParams.set('dates', dates)
      link.href = url.toString()
    }
  }

  updateDateRange() {
    const dateFrom = this.dateFromTarget.value;
    const amountOfDays = parseInt(this.amountOfDaysTarget.value);
    if (!dateFrom || isNaN(amountOfDays)) return;

    // Todo en fecha local. new Date("YYYY-MM-DD") la toma como UTC y toISOString()
    // la devuelve en UTC: en Argentina los dos corrimientos se compensan, pero es
    // casualidad, y con otro huso la fecha final queda un día corrida.
    const [year, month, day] = dateFrom.split('-').map(Number);
    const dateTo = new Date(year, month - 1, day + amountOfDays);
    const dateToValue = [
      dateTo.getFullYear(),
      String(dateTo.getMonth() + 1).padStart(2, '0'),
      String(dateTo.getDate()).padStart(2, '0')
    ].join('-');

    const dateRangeDiv = document.getElementById('deliveryPlacementBtn');
    dateRangeDiv.setAttribute('data-value', `${dateFrom},${dateToValue}`);
  }
}
